import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import Papers from './pages/Papers'
import Tasks from './pages/Tasks'
import Report from './pages/Report'
import ErrorBoundary from './components/ErrorBoundary'
import { ToastContainer } from './components/Toast'
import { isAuthenticated } from './services/auth'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  return isAuthenticated() ? <Layout>{children}</Layout> : <Navigate to="/login" replace />
}

function App() {
  return (
    <ErrorBoundary>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Papers /></PrivateRoute>} />
        <Route path="/tasks" element={<PrivateRoute><Tasks /></PrivateRoute>} />
        <Route path="/report/:taskId" element={<PrivateRoute><Report /></PrivateRoute>} />
      </Routes>
    </ErrorBoundary>
  )
}

export default App
